var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRidersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2939_26969)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FEF0F2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2939_26969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2939_26969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 9.79086 5.79086 8 8 8H32C34.2091 8 36 9.79086 36 12V50H4V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.61224,
    y: 10.6122,
    width: 11.102,
    height: 3.91837,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.204,
    y: 11.9183,
    width: 7.18367,
    height: 1.30612,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.61224,
    y: 29.551,
    width: 26.7755,
    height: 4.57143,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.61224,
    y: 35.4285,
    width: 26.7755,
    height: 16.3265,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.61224,
    y: 17.1428,
    width: 7.83673,
    height: 9.79592,
    rx: 0.653061,
    fill: "#E1F3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7551,
    y: 17.1428,
    width: 8.4898,
    height: 9.79592,
    rx: 0.653061,
    fill: "#FEEBEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.551,
    y: 17.1428,
    width: 7.83673,
    height: 9.79592,
    rx: 0.653061,
    fill: "#FEF7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5313 21.7144C11.3578 21.7144 12.0279 21.0443 12.0279 20.2178C12.0279 19.3912 11.3578 18.7212 10.5313 18.7212C9.70472 18.7212 9.03467 19.3912 9.03467 20.2178C9.03467 21.0443 9.70472 21.7144 10.5313 21.7144Z",
    fill: "#0EA3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5313 22.4626C9.03171 22.4626 7.81049 23.4684 7.81049 24.7075C7.81049 24.7914 7.87634 24.8572 7.96015 24.8572H13.1025C13.1863 24.8572 13.2521 24.7914 13.2521 24.7075C13.2521 23.4684 12.0309 22.4626 10.5313 22.4626Z",
    fill: "#0EA3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22.0408C20.8265 22.0408 21.4966 21.3708 21.4966 20.5442C21.4966 19.7177 20.8265 19.0476 20 19.0476C19.1734 19.0476 18.5034 19.7177 18.5034 20.5442C18.5034 21.3708 19.1734 22.0408 20 22.0408Z",
    fill: "#E60A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22.7891C18.5004 22.7891 17.2792 23.7948 17.2792 25.034C17.2792 25.1178 17.345 25.1836 17.4288 25.1836H22.5711C22.655 25.1836 22.7208 25.1178 22.7208 25.034C22.7208 23.7948 21.4996 22.7891 20 22.7891Z",
    fill: "#E60A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4688 22.041C30.2953 22.041 30.9654 21.371 30.9654 20.5445C30.9654 19.7179 30.2953 19.0479 29.4688 19.0479C28.6422 19.0479 27.9722 19.7179 27.9722 20.5445C27.9722 21.371 28.6422 22.041 29.4688 22.041Z",
    fill: "#F9C320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4688 22.7893C27.9692 22.7893 26.748 23.795 26.748 25.0342C26.748 25.118 26.8138 25.1839 26.8976 25.1839H32.04C32.1238 25.1839 32.1896 25.118 32.1896 25.0342C32.1896 23.795 30.9684 22.7893 29.4688 22.7893Z",
    fill: "#F9C320"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.7 12.95H36V14.85H35.7V16.75H36V18.65H35.7V20.55H36V22.45H35.7V24.35H36V26.25H35.7V28.15H36V30.05H35.7V31.95H36V33.85H35.7V35.75H36V37.65H35.7V39.55H36V41.45H35.7V43.35H36V45.25H35.7V47.15H36V49.05H35.7V49.7H35V50H33V49.7H31V50H29V49.7H27V50H25V49.7H23V50H21V49.7H19V50H17V49.7H15V50H13V49.7H11V50H9V49.7H7V50H5V49.7H4.3V49.05H4V47.15H4.3V45.25H4V43.35H4.3V41.45H4V39.55H4.3V37.65H4V35.75H4.3V33.85H4V31.95H4.3V30.05H4V28.15H4.3V26.25H4V24.35H4.3V22.45H4V20.55H4.3V18.65H4V16.75H4.3V14.85H4V12.95H4.3V12C4.3 11.7525 4.32426 11.511 4.37043 11.2776L4.07614 11.2194C4.17995 10.6946 4.38642 10.2067 4.67374 9.77754L4.92303 9.94443C5.19325 9.54081 5.54081 9.19325 5.94443 8.92303L5.77754 8.67374C6.2067 8.38642 6.69457 8.17995 7.21935 8.07614L7.27757 8.37043C7.51098 8.32426 7.75251 8.3 8 8.3H9V8H11V8.3H13V8H15V8.3H17V8H19V8.3H21V8H23V8.3H25V8H27V8.3H29V8H31V8.3H32C32.2475 8.3 32.489 8.32426 32.7224 8.37043L32.7806 8.07614C33.3054 8.17995 33.7933 8.38642 34.2225 8.67374L34.0556 8.92303C34.4592 9.19325 34.8068 9.54081 35.077 9.94443L35.3263 9.77754C35.6136 10.2067 35.82 10.6946 35.9239 11.2194L35.6296 11.2776C35.6757 11.511 35.7 11.7525 35.7 12V12.95Z",
    stroke: "#FCB6C0",
    strokeWidth: 0.6,
    strokeDasharray: "2 2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#FCB6C0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2939_26969",
    x: -2.53061,
    y: 4.08163,
    width: 45.0612,
    height: 55.0612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61224
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26531
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2939_26969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2939_26969",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2939_26969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2939_26969"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 9.79086 5.79086 8 8 8H32C34.2091 8 36 9.79086 36 12V50H4V12Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRidersIcon);
export default __webpack_public_path__ + "static/media/top-riders-icon.a75b0fffdb515cc14cd3efd42b62272b.svg";
export { ForwardRef as ReactComponent };